import React, { useEffect, useState } from "react";
import useApp from "hooks/useApp";
import { Button, LayerBottom } from "components";
import styles from "../index.module.css";
import Lib from "library";
import Native from "library/native";
import { useLocation, useNavigate } from "react-router-dom";
import Switch2 from "../../../components/Switch2";

const Success = () => {
  const App = useApp();
  const navigate = useNavigate();
  const [useBio, setUseBio] = useState(false);
  const [showLayer, setShowLayer] = useState(false);

  const location = useLocation();
  const isWelcome = !!location.state?.welcome;
  console.log("isWelcome 수신 >>>", isWelcome);

  const closeLayer = () => {
    setShowLayer(false);
  };

  const onConnect = () => {
    App.setDidRun(true);
    navigate("/member/loginGoData");
  };

  const onMain = () => {
    App.setDidRun(true);
    navigate("/home");
  };

  const bioInit = (t) => {
    Lib.post(
      "/api/mb/join/upd/bio",
      {
        bioAuthUseYn: t ? "Y" : "N",
      },
      (data) => {
        if (data) {
          window.localStorage.setItem("useBio", t);
          setUseBio(t);
        }
      }
    );
  };

  const setBioInfo = () => {
    if (!useBio) {
      Native.execute(
        "AppManager",
        "setAuthenticate",
        (result) => {
          const json = JSON.parse(result);

          if (json.result === "Success") {
            bioInit(!useBio);
          } else {
            console.error(decodeURI(json.result));
          }
        },
        { userid: window.localStorage.getItem("mbId") }
      );
    } else {
      bioInit(!useBio);
    }
  };

  useEffect(() => {
    App.setHeader({
      show: false,
      title: <></>,
      left: undefined,
      right: undefined,
    });

    App.setShowNav(false);
    App.setMainClass("white");
  }, []);

  const welcomeMessage = isWelcome
    ? "다시 만나서 반가워요!<br/><br/>" +
      "지금부터 새롭게 바뀐 모니<br/>" +
      "이용을 위해 회원님의<br/>" +
      "마이데이터 연동을 해보세요."
    : "회원가입이 완료되었어요.";

  return (
    <div className="page">
      <div className="flex_1 padding center-cont">
        <i className="icon icon_smile" />
        <WelcomeMessage welcomeMessage={welcomeMessage} />
      </div>
      <div className="flex-shrink_0 padding">
        <div className={styles["join-box"]}>
          <p className={styles.title}>간편 로그인 사용</p>
          <span className="mt_10">
            다음 로그인 시 간편로그인을 통해
            <br />
            쉽고 빠르게 접속이 가능해요.
          </span>
          <hr className="my_20" />
          <div className="flex-justify_between align_center">
            <p className={styles.title}>생체인증으로 로그인</p>
            <Switch2 on={useBio} onToggle={setBioInfo} />
          </div>
        </div>
        <div className="flex-shrink_0 mt_20 btn-group flex-full">
          <Button className="btn btn--big btn--gray" onClick={onMain}>
            메인으로 가기
          </Button>
          <Button className="btn btn--big ml_10" onClick={onConnect}>
            마이데이터 연결
          </Button>
        </div>
      </div>

      <ConfirmLayer show={showLayer} closeLayer={closeLayer} />
    </div>
  );
};

const WelcomeMessage = ({ welcomeMessage }) => {
  return <h3 className="intro-tit mt_30">{welcomeMessage}</h3>;
};

const ConfirmLayer = ({ show, closeLayer }) => {
  return (
    <LayerBottom
      show={show}
      closeButton={false}
      closeConfirm={closeLayer}
      outside={
        <Button className="btn btn--big btn-layer" onClick={() => closeLayer()}>
          확인
        </Button>
      }
    >
      <div className="layer-text">
        회원정보가 없어요.
        <br />
        입력하신 정보를 다시한번 확인해주세요.
      </div>
    </LayerBottom>
  );
};

export default Success;
